var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { map } from 'lodash';
import copy from 'copy-to-clipboard';
import pipe from 'app/core/utils/pipe';
import { ButtonList, MUIButton } from 'app/components/Form';
import { TabsRouter } from 'app/components/Tabs/Tabs.jsx';
import { assetIcons } from 'app/components/Icons/assetsIcons';
import { openPictures } from 'app/components/PictureVisualization/PictureVisualization';
import { Breadcrumb } from 'app/components/Breadcrumb/Breadcrumb.jsx';
import SubscribeButton from 'app/containers/Subscription/SubscribeButton.jsx';
import FontIcon from 'app/components/FontIcon/FontIcon.jsx';
import { Tooltip } from 'app/components/Tooltip/Tooltip.jsx';
import { assetsTypes } from 'app/core/constants';
import { success } from 'app/components/Notifications/notify';
import classes from 'app/containers/Assets/AssetDetail/AssetDetail.module.scss';
import Discussions from 'app/containers/Assets/AssetDetail/Discussions/Discussions.jsx';
import Infos from 'app/containers/Assets/AssetDetail/Infos/Infos';
import Wiki from 'app/containers/Assets/AssetDetail/Wiki/Wiki.jsx';
import { Notes } from 'app/containers/Assets/AssetDetail/Notes/Notes';
import Tasks from 'app/containers/Assets/AssetDetail/Tasks/Tasks';
import BreakdownShot from 'app/containers/Assets/AssetDetail/BreakdownShot/BreakdownShot';
import BreakdownEpisode from 'app/containers/Assets/AssetDetail/BreakdownEpisode/BreakdownEpisode';
import PostBoardShots from 'app/containers/Assets/AssetDetail/PostBoardShots/PostBoardShots';
import PostBoardModels from 'app/containers/Assets/AssetDetail/PostBoardModels/PostBoardModels';
import ValidationMedias from 'app/containers/Assets/AssetDetail/ValidationMedias/ValidationMedias.jsx';
import { Mozaic } from 'app/containers/Assets/AssetDetail/ValidationMedias/Mozaic';
import Usage from 'app/containers/Assets/AssetDetail/Usage/Usage';
import { router, Route, Link } from 'app/containers/Assets/AssetDetail/router';
import { fetchAsset } from 'app/store/reducers/assets';
import { assetSelector } from 'app/store/selectors/assets';
const AssetDetail = (props) => {
    const { breadcrumbProps, localRouter, assetId } = props;
    console.log('AssetDetail render', props);
    const dispatch = useDispatch();
    const asset = useSelector(assetSelector(assetId));
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (assetId) {
                yield dispatch(fetchAsset(assetId));
            }
        }))();
    }, [assetId]);
    const assetDetailRouter = (localRouter && localRouter.router) || router;
    const RouterEl = localRouter
        ? {
            Route: localRouter.Route,
            Link: localRouter.Link,
            router: localRouter.router,
        }
        : {
            Route,
            Link,
            router: assetDetailRouter,
        };
    const onClickBreadcrumbItem = (item) => {
        router.goTo('index', { assetId: item.id });
    };
    const onCopyTextToClipboard = () => {
        const { project: assetProject, id: assetId } = asset;
        const { origin } = window.location;
        copy(`${origin}/projects/${assetProject}/assets?assetDetails=/${assetId}/informations`);
        success('Copied to clipboard');
    };
    const getLinks = () => {
        if (!asset)
            return {};
        const assetId = asset.id;
        const assetProject = asset.project;
        const informations = {
            key: 'informations',
            permission: ['Overmind_Asset sheets_Tabs_Informations'],
            name: 'informations',
            params: { assetId },
            label: 'Information',
        };
        const discussions = {
            permission: ['Overmind_Asset sheets_Tabs_Discussions'],
            projectId: assetProject,
            key: 'discussions',
            name: 'discussions',
            params: { assetId },
            label: 'Discussions',
        };
        const wiki = {
            projectId: assetProject,
            permission: ['Overmind_Asset sheets_Tabs_Wiki'],
            key: 'wiki',
            name: 'wiki',
            params: { assetId },
            label: 'Wiki',
        };
        const tasks = {
            projectId: assetProject,
            permission: ['Overmind_Asset sheets_Tabs_Tasks'],
            key: 'tasks',
            name: 'tasks',
            params: { assetId },
            label: 'Tasks',
        };
        const medias = {
            projectId: assetProject,
            permission: [
                'Overmind_Asset sheets_Tabs_Media - Mozaic',
                'Overmind_Asset sheets_Tabs_Media - Mozaic (All medias)',
                'Overmind_Asset sheets_Tabs_Media - Validation Medias',
            ],
            operator: 'or',
            key: 'medias',
            name: 'medias',
            activeName: 'mozaic',
            params: { assetId },
            subList: [
                {
                    label: 'Mozaic',
                    key: 'mozaic',
                    name: 'mozaic',
                    permission: ['Overmind_Asset sheets_Tabs_Media - Mozaic'],
                    projectId: assetProject,
                    params: { assetId },
                    parent: 'medias',
                },
                {
                    label: 'Mozaic (all medias)',
                    key: 'mozaicAllMedias',
                    name: 'mozaicAllMedias',
                    permission: ['Overmind_Asset sheets_Tabs_Media - Mozaic (All medias)'],
                    projectId: assetProject,
                    params: { assetId },
                    parent: 'medias',
                },
                {
                    label: 'Validation medias',
                    key: 'validationMedias',
                    name: 'validationMedias',
                    permission: ['Overmind_Asset sheets_Tabs_Media - Validation Medias'],
                    projectId: assetProject,
                    params: { assetId },
                    parent: 'medias',
                },
            ],
            label: 'Medias',
        };
        const breakdownShot = {
            projectId: assetProject,
            permission: ['Overmind_Asset sheets_Tabs_Breakdown'],
            key: 'breakdownShot',
            name: 'breakdownShot',
            params: { assetId },
            label: 'Breakdown',
        };
        const breakdownEpisode = {
            projectId: assetProject,
            permission: ['Overmind_Asset sheets_Tabs_Breakdown'],
            key: 'breakdownEpisode',
            name: 'breakdownEpisode',
            params: { assetId },
            label: 'Breakdown',
        };
        const notes = {
            projectId: assetProject,
            permission: ['Overmind_Asset sheets_Tabs_Notes'],
            key: 'notes',
            name: 'notes',
            params: { assetId },
            label: 'Notes',
        };
        const postBoardShots = {
            permission: ['Overmind_Asset sheets_Tabs_Shot Notes'],
            projectId: assetProject,
            key: 'postBoardShots',
            name: 'postBoardShots',
            params: { assetId },
            label: 'Shots Notes',
        };
        const postBoardModels = {
            permission: ['Overmind_Asset sheets_Tabs_Model Notes'],
            projectId: assetProject,
            key: 'postBoardModels',
            name: 'postBoardModels',
            params: { assetId },
            label: 'Models Notes',
        };
        const usage = {
            permission: ['Overmind_Asset sheets_Tabs_Usage'],
            key: 'usage',
            name: 'usage',
            params: { assetId },
            label: 'Usage',
        };
        let customNav = { informations, discussions, wiki, tasks };
        switch (asset.assetType) {
            case 'fo':
                customNav = Object.assign(Object.assign({}, customNav), { medias });
                break;
            case 'sh':
                customNav = Object.assign(Object.assign({}, customNav), { breakdownShot, medias, notes });
                break;
            case 'ep':
                customNav = Object.assign(Object.assign({}, customNav), { breakdownEpisode, postBoardShots, postBoardModels, medias });
                break;
            case 'mo':
                customNav = Object.assign(Object.assign({}, customNav), { usage, medias, notes });
                break;
            default:
                break;
        }
        return customNav;
    };
    const tabs = getLinks();
    if (!asset) {
        return (_jsx("div", { className: "fullWidth fullHeight flex center alignCenter grey fontSize16 grey bold", children: "Can't find this asset." }));
    }
    return (_jsxs("div", { className: classes.container, children: [_jsx("div", { children: _jsx(Breadcrumb, Object.assign({ asset: asset, onClick: onClickBreadcrumbItem }, breadcrumbProps)) }), _jsxs(ButtonList, { style: { justifyContent: 'flex-end', position: 'absolute', top: 10, right: 10 }, children: [_jsx(MUIButton, { onClick: onCopyTextToClipboard, icon: "fas-link", color: "primary", dataCy: "asset-copy", tooltip: "Copy url in the clipboard" }), _jsx(SubscribeButton, { target: asset, targetType: "asset" })] }), _jsxs("div", { className: classes.topContent, children: [asset.thumbnailInst ? (_jsx("div", { className: classes.image, children: _jsx("img", { src: asset.thumbnailInst.url, onClick: () => {
                                asset.thumbnailInst ? openPictures([asset.thumbnailInst], false, false, 0) : undefined;
                            } }) })) : null, _jsxs("div", { className: classes.infos, children: [_jsxs("div", { className: classes.name, style: asset.internalStatus === 2 ? { textDecoration: 'line-through' } : undefined, children: [_jsx(Tooltip, { title: assetsTypes[asset.assetType], children: _jsx(FontIcon, { icon: assetIcons(asset.assetType), className: "marginRight10" }) }), asset.name] }), asset.internalStatus === 2 ? _jsx("div", { className: classes.removed, children: "Removed" }) : null, _jsx("div", {})] })] }), _jsx("div", { className: classes.tabsRouter, children: _jsxs(TabsRouter, { tabs: map(tabs), localRouter: RouterEl, className: classes.tabs, contentStyle: {
                        display: 'flex',
                        flex: 1,
                        justifyContent: 'center',
                    }, children: [tabs.informations ? (_jsx(RouterEl.Route, { permission: ['Overmind_Asset sheets_Tabs_Informations'], name: "informations", component: Infos, componentProps: { asset } })) : null, tabs.discussions ? (_jsx(RouterEl.Route, { permission: ['Overmind_Asset sheets_Tabs_Discussions'], projectId: asset.project, name: "discussions", component: Discussions, componentProps: { asset, router } })) : null, tabs.medias
                            ? [
                                _jsx(RouterEl.Route, { permission: ['Overmind_Asset sheets_Tabs_Media - Mozaic'], operator: "or", projectId: asset.project, name: "mozaic", component: Mozaic, componentProps: { asset, pinned: true } }, "mozaic"),
                                _jsx(RouterEl.Route, { permission: ['Overmind_Asset sheets_Tabs_Media - Mozaic (All medias)'], operator: "or", projectId: asset.project, name: "mozaicAllMedias", component: Mozaic, componentProps: { asset } }, "mozaicAllMedias"),
                                _jsx(RouterEl.Route, { permission: ['Overmind_Asset sheets_Tabs_Media - Validation Medias'], operator: "or", projectId: asset.project, name: "validationMedias", component: ValidationMedias, componentProps: { asset } }, "validationMedias"),
                            ]
                            : null, tabs.wiki ? (_jsx(RouterEl.Route, { permission: ['Overmind_Asset sheets_Tabs_Wiki'], name: "wiki", component: Wiki, componentProps: { asset } })) : null, tabs.tasks ? (_jsx(RouterEl.Route, { permission: ['Overmind_Asset sheets_Tabs_Tasks'], projectId: asset.project, name: "tasks", component: Tasks, componentProps: { asset } })) : null, tabs.notes ? (_jsx(RouterEl.Route, { permission: ['Overmind_Asset sheets_Tabs_Notes'], projectId: asset.project, name: "notes", component: Notes, componentProps: { asset } })) : null, tabs.breakdownShot ? (_jsx(RouterEl.Route, { permission: ['Overmind_Asset sheets_Tabs_Breakdown'], projectId: asset.project, name: "breakdownShot", component: BreakdownShot, componentProps: { asset } })) : null, tabs.breakdownEpisode ? (_jsx(RouterEl.Route, { permission: ['Overmind_Asset sheets_Tabs_Breakdown'], projectId: asset.project, name: "breakdownEpisode", component: BreakdownEpisode, componentProps: { asset } })) : null, tabs.postBoardModels ? (_jsx(RouterEl.Route, { permission: ['Overmind_Asset sheets_Tabs_Model Notes'], projectId: asset.project, name: "postBoardModels", component: PostBoardModels, componentProps: { asset } })) : null, tabs.postBoardShots ? (_jsx(RouterEl.Route, { permission: ['Overmind_Asset sheets_Tabs_Shot Notes'], projectId: asset.project, name: "postBoardShots", component: PostBoardShots, componentProps: { asset } })) : null, tabs.usage ? (_jsx(RouterEl.Route, { permission: ['Overmind_Asset sheets_Tabs_Usage'], name: "usage", component: Usage, componentProps: { asset } })) : null] }, asset.id) })] }));
};
const AssetDetailContainer = pipe()
    .withRouter()
    .connect((state, props) => {
    const { params } = props;
    const { assetId } = params;
    return { assetId };
})
    .render(AssetDetail);
export default function (props) {
    const { localRouter } = props;
    const Component = localRouter ? localRouter.Route : Route;
    return _jsx(Component, { name: "asset", component: AssetDetailContainer, componentProps: props });
}
